<template>
  <div class="login-page">
    <b-container class="d-flex justify-content-center align-items-center h-100">
      <b-card class="login-card" header="Login" header-tag="h2">
        <b-form @submit.prevent="loginUser">
          <b-form-group label="Email" label-for="email">
            <b-form-input
              v-model="email"
              type="email"
              id="email"
              required
              placeholder="Enter your email"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Password" label-for="password">
            <b-form-input
              v-model="password"
              type="password"
              id="password"
              required
              placeholder="Enter your password"
            ></b-form-input>
          </b-form-group>

          <b-button class="btn-fill" type="submit" variant="primary" block>Login</b-button>
        </b-form>

        <div class="register-prompt text-center mt-3">
          <p>Don't have a Cloud AM account?
            <b-link @click="goToRegister">Register instead</b-link>
          </p>
        </div>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import apiClient from "@/http";
export default {
  data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    async loginUser() {
      try {
        let response = await apiClient.post('/auth/user-session', {
          email: this.email,
          password: this.password
        });
        const tokenData = response.data;
        localStorage.setItem('authToken', tokenData.access_token);

        // Redirect to the main page after storing the token
        window.location.href = '/';
      } catch (error) {
        console.error(error);
        if (error.response) {
          if (error.response.status === 412) {
            this.$bvToast.toast('User is not verified, check email', {
              title: 'Error',
              variant: 'danger',
              solid: true
            });
          } else {
            this.$bvToast.toast('Email or password incorrect', {
              title: 'Error',
              variant: 'danger',
              solid: true
            });
          }
          this.email = '';
          this.password = '';
        }
      }

    },
    goToRegister() {
      this.$router.push('/register');
    }
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.login-card {
  max-width: 400px;
  width: 100%;
  padding: 20px;
  border-radius: 8px;
}

.register-prompt {
  font-size: 14px;
  color: #666;
}

.register-prompt b-link {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
